export enum MODE {
  GAME = "GAME",
  EDITOR = "EDITOR",
}
